import { Button, Col, List, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import slugify from "react-slugify";
import SEO from "../../../seo/SEO";
import {
  getBlogs,
  getCategoryProducts,
  setCountryName,
  SEARCH_RESULTS,
} from "../../../store/actions/homepageActions";
import BlogCard from "../blogs/BlogCard";
import ProductCard from "./ProductCard";

const ProductsListPagination = ({ path = "", loc = "" }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);
  const [toggleSort, setToggleSort] = useState(false);
  const [blogs, setBlogs] = useState([]);

  const productsFromStore =
    useSelector((state) => state.home.productsDataArrays) || [];
  const blogData = useSelector((state) => state.home.getAllBlogs) || [];
  const searchData = useSelector((state) => state.home.searchResults) || [];
  // console.log("searchData", searchData);
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      const result = await dispatch(getCategoryProducts(loc));
      if (result && result.length) setAllProducts(result);
      setLoading(false);
    };

    if (path === "/" || productsFromStore.length < 1) {
      fetchProducts();
    } else {
      setAllProducts(productsFromStore);
    }
  }, [dispatch, loc, path, productsFromStore]);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      const res = await dispatch(getBlogs());
      if (res) setBlogs(res);
      setLoading(false);
    };
    if (blogData.length > 0) {
      setBlogs([...blogData].sort((a, b) => b.data.id - a.data.id));
    } else {
      fetchBlogs();
    }
  }, [dispatch, blogData]);

  useEffect(() => {
    let filtered = allProducts;
    const categoryMatch = (keywords) => (item) =>
      keywords.some((k) => item.categories[0].name.toLowerCase().includes(k));

    const filterMap = {
      "/electronics": categoryMatch([
        "smartphones",
        "electronics",
        "cell phones",
        "home theater audio",
      ]),
      "/projectors": (item) =>
        item.categories[0].name.toLowerCase().includes("video projectors") ||
        item.title.toLowerCase().includes("projector"),
      "/oled-tv": (item) =>
        item.categories[0].name.toLowerCase().includes("oled tvs") ||
        item.title.toLowerCase().includes("oled"),
      "/appliances": categoryMatch([
        "refrigerators",
        "washers",
        "washing machines",
        "steam cleaners",
      ]),
      "/car-accessories": categoryMatch(["car electronics"]),
    };

    if (filterMap[path]) filtered = allProducts.filter(filterMap[path]);

    setFilteredProducts(filtered);
    setSortedProducts(filtered);
  }, [path, allProducts]);

  const handleSort = (type) => {
    let sorted = [...filteredProducts];
    if (type === "rate") {
      sorted.sort((a, b) =>
        toggleSort ? a.rating - b.rating : b.rating - a.rating
      );
      setToggleSort(!toggleSort);
    } else if (type === "LTH") {
      sorted = sorted
        .filter((p) => p.price?.value)
        .sort((a, b) => a.price.value - b.price.value);
    } else if (type === "HTL") {
      sorted = sorted
        .filter((p) => p.price?.value)
        .sort((a, b) => b.price.value - a.price.value);
    } else if (type === "Reset") {
      sorted = filteredProducts;
    }
    setSortedProducts(sorted);
  };

  return (
    <Row className="list-parent" style={{ padding: "16px" }}>
      <SEO
        title={`Best ${
          path.slice(1).charAt(0).toUpperCase() + path.slice(2)
        } Category Products`}
      />
      {loading ? (
        <Col
          span={24}
          style={{ textAlign: "center", height: 500, paddingTop: "8%" }}
        >
          <Spin size="large" tip="Loading..." />
        </Col>
      ) : (
        <>
          <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
            <Col>
              <Button onClick={() => handleSort("rate")}>
                Customer Rating
              </Button>
            </Col>
            <Col>
              <Button onClick={() => handleSort("LTH")}>Low to High</Button>
            </Col>
            <Col>
              <Button onClick={() => handleSort("HTL")}>High to Low</Button>
            </Col>
            <Col>
              <Button onClick={() => handleSort("Reset")}>Reset</Button>
            </Col>
          </Row>

          <List
            grid={{ gutter: 12, xs: 1, sm: 1, md: 2, lg: 3, xl: 4, xxl: 4 }}
            pagination={{ pageSize: 12, hideOnSinglePage: true }}
            dataSource={searchData.length > 0 ? searchData : sortedProducts}
            renderItem={(item, index) => (
              <List.Item key={index}>
                <ProductCard data={item} path={path} loc={loc} />
              </List.Item>
            )}
          />

          {blogs.length > 0 && (
            <div>
              <h2>Recent Blog Articles</h2>
              <List
                grid={{ gutter: 12, xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 2 }}
                pagination={{ pageSize: 6, hideOnSinglePage: true }}
                dataSource={blogs}
                renderItem={(item, index) => (
                  <List.Item key={index}>
                    <BlogCard data={item} path={path} loc={loc} />
                  </List.Item>
                )}
              />
            </div>
          )}
        </>
      )}
    </Row>
  );
};

export default ProductsListPagination;
